// OptionCard — selectable icon + label tile used by the company creation wizard
// (industry and feature grids). Shows a check badge when selected.

import Icon from '@/components/common/Icon';

interface OptionCardProps {
  icon?: string;
  label: string;
  selected: boolean;
  /** Tint the icon brand-green even when unselected (features step). */
  accent?: boolean;
  onClick: () => void;
}

const OptionCard = ({ icon, label, selected, accent = false, onClick }: OptionCardProps) => {
  const classes = [
    'company-creation__option',
    selected && 'company-creation__option--selected',
    accent && 'company-creation__option--accent',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button type='button' className={classes} onClick={onClick} aria-pressed={selected}>
      {selected && (
        <span className='company-creation__option-check' aria-hidden='true'>
          <Icon name='check' size={12} />
        </span>
      )}
      {icon && (
        <Icon name={icon} size={24} className='company-creation__option-icon' aria-hidden='true' />
      )}
      <span className='company-creation__option-label'>{label}</span>
    </button>
  );
};

export default OptionCard;
